module.exports = __webpack_public_path__ + "static/iso-logo-b3d47857981177031498dfee560a21ee.png";